export default "/_next/static/images/7898170f5746c4d0d2ef39fc4204bafc.jpg";